import { displayValue } from './month';
//  value and display are same for creating dynamic forms
export const JobTitle: displayValue[] = [
  { value: 'Billing', display: 'Billing' },
  { value: 'Developer/Engineer', display: 'Developer/Engineer' },
  { value: 'Dispatcher', display: 'Dispatcher' },
  { value: 'Operations Manager', display: 'Operations Manager' },
  { value: 'President/Owner', display: 'President/Owner' },
  { value: 'Project Manager', display: 'Project Manager' },
  { value: 'Other', display: 'Other' },
];
